import { DrawingToolMenuItem } from './drawingToolMenu'
import TextIcon from '../../../../assets/icons/drawingTools/text'
import AnchoredTextIcon from '../../../../assets/icons/drawingTools/anchoredText'
import PriceNoteIcon from '../../../../assets/icons/drawingTools/priceNote'

export const textToolsMenuItems: DrawingToolMenuItem[] = [
    {
        drawingToolId: 'text',
        text: 'Text',
        icon: <TextIcon />,
        drawingType: 'text',
        toolOptions: {}
    },
    {
        drawingToolId: 'anchoredText',
        text: 'Anchored Text',
        icon: <AnchoredTextIcon />,
        drawingType: 'anchoredText',
        toolOptions: {
            textType: 'anchored'
        }
    },
    {
        drawingToolId: 'priceNote',
        text: 'Price Note',
        icon: <PriceNoteIcon />,
        drawingType: 'priceNote',
        toolOptions: {}
    }
]